import React from 'react';
import { MapPin, Phone, Mail, Facebook, ChevronUp } from 'lucide-react';
import { companyData } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLegalClick = (page) => {
    window.location.hash = page;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-teal-400">ADMIN</span> Hausverwaltung
            </h3>
            <p className="text-slate-400 mb-2">
              Inh. {companyData.owner}
            </p>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed">
              Ihre zuverlässige Hausverwaltung in Magdeburg und Umgebung. 
              Über 20 Jahre Erfahrung in Immobilienverwaltung, Vermietung und Hausmeisterservice.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/hausverwaltungadmin/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400">
                  {companyData.address.street}<br />
                  {companyData.address.zip} {companyData.address.city}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-teal-400 flex-shrink-0" />
                <a href={`tel:${companyData.contact.phone.replace(/\s/g, '')}`} className="text-slate-400 hover:text-teal-400 transition-colors">
                  {companyData.contact.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-teal-400 flex-shrink-0" />
                <a href={`mailto:${companyData.contact.email}`} className="text-slate-400 hover:text-teal-400 transition-colors break-all">
                  {companyData.contact.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Rechtliches</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleLegalClick('impressum')}
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Impressum
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleLegalClick('datenschutz')}
                  className="text-slate-400 hover:text-teal-400 transition-colors"
                >
                  Datenschutzerklärung
                </button>
              </li>
            </ul>

            {/* Tax Info */}
            <div className="mt-6 pt-6 border-t border-slate-800">
              <p className="text-sm text-slate-500">
                St.-Nr.: {companyData.taxInfo.steuerNr}<br />
                Finanzbehörde: {companyData.taxInfo.finanzbehoerde}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {currentYear} ADMIN Hausverwaltung. Alle Rechte vorbehalten.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-slate-500 hover:text-teal-400 transition-colors text-sm"
              aria-label="Nach oben scrollen"
            >
              <span>Nach oben</span>
              <ChevronUp className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
